__webpack_require__.p = "https://vitaverde-frontend.greensky-92f80007.eastus.azurecontainerapps.io/";